var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConclude({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1667 7.49967L9.16667 12.4997M9.16667 7.49967L14.1667 12.4997M2.26667 10.7997L5.86667 15.5997C6.16 15.9908 6.30667 16.1863 6.49254 16.3274C6.65717 16.4523 6.8436 16.5455 7.04231 16.6023C7.26667 16.6663 7.51111 16.6663 8 16.6663H14.3333C15.7335 16.6663 16.4335 16.6663 16.9683 16.3939C17.4387 16.1542 17.8212 15.7717 18.0609 15.3013C18.3333 14.7665 18.3333 14.0665 18.3333 12.6663V7.33301C18.3333 5.93288 18.3333 5.23281 18.0609 4.69803C17.8212 4.22763 17.4387 3.84517 16.9683 3.60549C16.4335 3.33301 15.7335 3.33301 14.3333 3.33301H8C7.51111 3.33301 7.26667 3.33301 7.04231 3.39708C6.8436 3.45384 6.65717 3.54705 6.49254 3.67197C6.30667 3.81301 6.16 4.00856 5.86667 4.39967L2.26667 9.19967C2.05151 9.48656 1.94392 9.63 1.90245 9.78753C1.86585 9.92659 1.86585 10.0728 1.90245 10.2118C1.94392 10.3694 2.05151 10.5128 2.26667 10.7997Z",
    stroke: "#101828",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConclude);
export default __webpack_public_path__ + "static/media/conclude.c66857ab552a2da8eac091b12a06ddf5.svg";
export { ForwardRef as ReactComponent };